import type { ApolloError } from '@apollo/client'
import { showError } from 'helpers/message'

export const defaultMutationErrorHandler = (err: ApolloError) => {
  showError(err.name, {
    description: err.message,
    optionalExtraInfo: [err.extraInfo],
  })
}
